import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import React, { useRef, useState, useEffect } from "react";
import { Button } from 'wbm-inputs';
import { CardHeader } from '../../components/formElements/headerText';

export interface ISliderProps {
    sliderObject: Array<object>;
    headerText: string,
    sliderKey: string
}

export const Slider = ({
    ...props
}: ISliderProps) => {
    const [scrollReset, setReset] = useState(false);
    const slider = useRef<any>(null);

    const [overFlown, setOverFlown] = useState(false)
    const [loaded, setLoaded] = useState(false)

    function handleResize() {
        hideButton(document.getElementById(props.sliderKey));
    }

    function hideButton(element: any) {
        if (loaded && element) {
            if (element.scrollWidth > element.offsetWidth) {
                setOverFlown(true);
            } else {
                setOverFlown(false);
            }
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        if (!loaded) {
            setLoaded(true);
        } else {
            hideButton(document.getElementById(props.sliderKey));
        }
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    })

    return (
        <div className="wbm-slider">
            <div>
                <CardHeader
                    text={props.headerText}
                />
            </div>
            <div
                className="wbm-slider-child"
                id={props.sliderKey}
                ref={slider}
                onScroll={(event: React.UIEvent<HTMLElement>) => {
                    let element = event.target as HTMLDivElement;
                    let showRight =
                        element.scrollWidth > element.offsetWidth &&
                        slider.current.clientWidth -
                        slider.current.scrollWidth +
                        slider.current.scrollLeft <
                        -30; // width of the button
                    setReset(element.scrollWidth > element.offsetWidth && !showRight);
                }}
            >

                <Button
                    className={overFlown ? `btn-primary round scroll-filter-button` : `btn-primary round scroll-filter-button no-overflown-content`}
                    style={{
                        position: 'absolute',
                        zIndex: '1'
                    }}
                    aria-label={"scroll slider"}
                    onClick={() => {
                        slider.current.scroll({
                            top: slider.current.scrollTop,
                            left: scrollReset
                                ? 0
                                : Math.min(
                                    slider.current.scrollWidth,
                                    slider.current.scrollLeft + slider.current.offsetWidth
                                ),
                            behavior: "smooth",
                        });
                    }}
                >
                    {!scrollReset &&
                        <ChevronRightIcon />
                    }
                    {scrollReset &&
                        <ChevronLeftIcon />
                    }
                </Button>
                {props.sliderObject && props.sliderObject.map((component, index) => {
                    return (
                        <React.Fragment key={index}>
                            <div className="slider-item slider-filter-container">
                                {component}
                                </div>
                            </React.Fragment>
                        //<div className="slider-item">
                        //<MerchandiseSliderItem {...(component as IMerchandiseSliderItemProps)}
                        //    />
                        //    </div>
                    );
                })}
                <span style={{ marginRight: 44 }}></span>
            </div>
        </div>

    );

};